import { Component } from '@angular/core';
import {CadastrosGeraisService} from "../../services/cadastros-gerais.service";
import {TipoTarefa} from "../models/tipo-tarefa";
import {ToastrService} from "ngx-toastr";
import Swal from "sweetalert2";

@Component({
    selector: 'app-tipo-tarefa',
    templateUrl: './tipo-tarefa.component.html',
    styleUrl: './tipo-tarefa.component.css',
    standalone: false
})
export class TipoTarefaComponent {
  loading = true;
  public colunas = ['Id', 'Descrição', 'Valor base', 'Dias execução'];
  public linhas: any[] = [];
  lista: TipoTarefa[] = [];
  tipoTarefa = new TipoTarefa();
  adicionar = false;
  paginaAtual = 1;

  constructor(private cadastrosGeraisService: CadastrosGeraisService,
              private toastr: ToastrService) {
    this.buscarLista();
  }

  private buscarLista(): void {
    this.cadastrosGeraisService.selecionarListaTipoTarefas().subscribe(response => {
      if(response.sucesso)
      {
        this.lista = [];
        this.lista = response.dados;
      }
    });
    this.loading = false;
  }

  public pageChange(event: number){
    this.paginaAtual = event;
  }

  public showModal() {
    this.adicionar = true;
  }

  public fecharModal(){
    this.adicionar = false;
  }

  public salvar(){
    this.loading = true;
    this.cadastrosGeraisService.adicionarTipoTarefa(this.tipoTarefa).subscribe(resultado => {
      if(resultado.sucesso){
        this.toastr.success("Tipo de tarefa adicionado com sucesso!");
        this.fecharModal();
        this.linhas = [];
        this.buscarLista();
      }
      else{
        this.toastr.error(resultado.errors[0].mensagem);
      }
    }, error => {
      this.toastr.error(error);
    });
    this.loading = false;
  }

  public desativar(id: number){
    this.loading = true;
    Swal.fire({
      title: 'Deseja realmente desativar?',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Sim',
      confirmButtonColor: '#fd7e14',
      cancelButtonText: 'Cancelar'
    }).then((result) => {
      if (result.isConfirmed) {
        this.cadastrosGeraisService.desativarTipoTipoTarefas(id).subscribe(resultado => {
          if(resultado.sucesso){
            this.toastr.success("Desativado com sucesso");
            this.buscarLista();
          }
        })
      }
    });
    this.loading = false;
  }
}
